import { IGetAllColetaPrecoFornecedorUseCase } from "../../../presentation/useCases/read/get_all_coleta_preco_fornecedor_use_case";
import { ColetaPrecoFornecedor } from "../../models/coleta_preco_fornecedor";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * GetAllColetaPrecoFornecedorUseCase
 */

export class GetAllColetaPrecoFornecedorUseCase implements IGetAllColetaPrecoFornecedorUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async getAllColetaPrecoFornecedor(
    idColetaPreco: number | undefined,
  ): Promise<ColetaPrecoFornecedor[]> {
    if (idColetaPreco === undefined) throw new Error('Id de coleta de preço invalido!');
    return await this.repository.getAllColetaPrecoFornecedor(
      idColetaPreco,
    );
  }
}
